import { useEffect, useState } from 'react';

const PasswordStrengthBar = ({ password }) => {
  const [strengthScore, setStrengthScore] = useState(0);

  const _width = password?.length > 0 ? `${(strengthScore + 1) * 20}%` : '0%'; // 0-4 → 25%, 50%, 75%, 100%
  const colors = ['#d44949', '#e27854', '#daa14d', '#6bc96b', '#49a04c'];

  useEffect(() => {
    if (password) {
      import('zxcvbn').then((module) => {
        setStrengthScore(module.default(password).score);
      });
    }
  }, [password]);

  return (
    <div>
      <div
        style={{
          width: '100%',
          height: '6px',
          backgroundColor: '#e0e0e0',
          borderRadius: '3px',
          margin: '8px 0',
        }}
      >
        <div
          style={{
            width: _width,
            height: '100%',
            backgroundColor: colors[strengthScore],
            borderRadius: 'inherit',
            transition: 'width 0.3s ease',
          }}
        />
      </div>
      <div style={{ fontSize: '14px', color: colors[strengthScore], width: '100%', display: 'flex', justifyContent: 'flex-end', visibility: password?.length > 0 ? 'visible' : 'hidden' }}>
        {/*  */}
        {['Too short', 'Weak', 'Medium', 'Strong', 'Very strong'][strengthScore]}
      </div>
    </div>
  );
};

export default PasswordStrengthBar;
